import React, { Component } from 'react';
import './../../../styles/heading.css'

export default class H2Title extends Component {
    render() {
        return (
        <h4 className="mb-3 ml-2 voo-underline heading" >{this.props.value}</h4>
        );
    }
};